var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.875 83.4771H28.125V126.865C28.125 128.934 29.482 130.76 31.4648 131.355C40.8844 134.179 67.3734 142.127 73.6523 144.011C74.5312 144.274 75.4688 144.274 76.3477 144.011C82.6266 142.127 109.116 134.179 118.535 131.355C120.518 130.76 121.875 128.934 121.875 126.865C121.875 115.999 121.875 83.4771 121.875 83.4771Z",
    fill: "url(#paint0_linear_245_4150)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.875 83.4771H75.0004C75.0004 83.4771 74.5457 144.208 75.0004 144.208C75.4551 144.208 75.9075 144.143 76.3481 144.011C82.627 142.127 109.116 134.179 118.536 131.355C120.518 130.76 121.875 128.934 121.875 126.865C121.875 115.999 121.875 83.4771 121.875 83.4771Z",
    fill: "url(#paint1_linear_245_4150)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0002 98.6856L28.1252 83.4771C28.1252 83.4771 19.9057 95.6645 16.2307 101.111C15.8182 101.723 15.7174 102.49 15.9565 103.186C16.1979 103.882 16.7487 104.423 17.4494 104.653C26.3534 107.545 52.7112 116.109 59.6252 118.354C60.6166 118.678 61.7041 118.305 62.2901 117.44C65.433 112.802 75.0002 98.6856 75.0002 98.6856Z",
    fill: "url(#paint2_linear_245_4150)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.875 83.4771L75 98.6856C75 98.6856 84.5672 112.802 87.7102 117.44C88.2961 118.305 89.3836 118.678 90.375 118.354C97.2891 116.109 123.647 107.545 132.551 104.653C133.252 104.423 133.802 103.882 134.044 103.186C134.283 102.49 134.182 101.723 133.77 101.111C130.095 95.6645 121.875 83.4771 121.875 83.4771Z",
    fill: "url(#paint3_linear_245_4150)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6543 51.5292C63.0684 50.6691 61.9832 50.2964 60.9918 50.6199C54.0825 52.8628 27.7176 61.4292 18.8137 64.3238C18.1129 64.5511 17.5598 65.0925 17.3207 65.7886C17.0817 66.4847 17.1825 67.2535 17.595 67.8628C20.9793 72.8832 28.1254 83.4769 28.1254 83.4769L75.0004 68.2167C75.0004 68.2167 66.5817 55.8347 63.6543 51.5292Z",
    fill: "url(#paint4_linear_245_4150)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.405 67.8628C132.818 67.2535 132.919 66.4847 132.68 65.7886C132.441 65.0925 131.888 64.5511 131.187 64.3238C122.283 61.4292 95.918 52.8628 89.0086 50.6199C88.0172 50.2964 86.932 50.6691 86.3461 51.5292C83.4187 55.8347 75 68.2167 75 68.2167L121.875 83.4769C121.875 83.4769 129.021 72.8832 132.405 67.8628Z",
    fill: "url(#paint5_linear_245_4150)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.875 83.477L75 68.2168L28.125 83.477L75 98.6855L121.875 83.477Z",
    fill: "url(#paint6_linear_245_4150)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 98.6855V68.2168L28.125 83.477L75 98.6855Z",
    fill: "url(#paint7_linear_245_4150)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5828 74.9485C64.6078 74.311 63.7289 73.6289 62.9485 72.9141C61.9969 72.0399 60.5133 72.1032 59.6367 73.0571C58.7625 74.0086 58.8258 75.4922 59.7797 76.3664C60.7383 77.2477 61.8188 78.0868 63.0188 78.8719C64.1016 79.5797 65.5547 79.275 66.2625 78.1922C66.9703 77.1094 66.6657 75.6563 65.5828 74.9485Z",
    fill: "url(#paint8_linear_245_4150)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2799 67.7482C57.5838 66.8037 56.9955 65.8545 56.5127 64.9053C55.9267 63.7521 54.5135 63.2928 53.3603 63.8787C52.2072 64.4646 51.7478 65.8779 52.3338 67.031C52.9291 68.1982 53.651 69.3678 54.5064 70.5279C55.2728 71.5685 56.74 71.7912 57.783 71.0248C58.8236 70.256 59.0463 68.7889 58.2799 67.7482Z",
    fill: "url(#paint9_linear_245_4150)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8532 58.1833C54.8766 57.2388 55.0149 56.3224 55.268 55.4435C55.6243 54.2013 54.9048 52.9005 53.6602 52.5443C52.418 52.188 51.1173 52.9076 50.761 54.1521C50.4024 55.4083 50.2009 56.7185 50.1657 58.0662C50.1352 59.3599 51.1571 60.4357 52.4509 60.4662C53.7446 60.499 54.8204 59.4771 54.8532 58.1833Z",
    fill: "url(#paint10_linear_245_4150)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4577 50.3552C59.06 49.7974 59.735 49.2818 60.4733 48.8154C61.5678 48.124 61.896 46.6755 61.2069 45.5834C60.5155 44.4888 59.067 44.1607 57.9725 44.8498C56.9811 45.4755 56.0811 46.1669 55.2725 46.9169C54.3233 47.7959 54.267 49.2794 55.146 50.2287C56.0249 51.1779 57.5085 51.2341 58.4577 50.3552Z",
    fill: "url(#paint11_linear_245_4150)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1741 46.3126C68.353 46.0947 69.6022 45.954 70.9194 45.9001C72.2131 45.8439 73.2163 44.7493 73.1624 43.4579C73.1085 42.1665 72.0139 41.1611 70.7202 41.215C69.1733 41.2806 67.7061 41.447 66.321 41.7025C65.0506 41.9392 64.2069 43.1626 64.4436 44.4329C64.678 45.7056 65.9014 46.547 67.1741 46.3126Z",
    fill: "url(#paint12_linear_245_4150)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.39 46.1742C81.3893 46.1977 83.2502 46.1273 84.9775 45.975C86.2666 45.8602 87.2205 44.7211 87.1057 43.432C86.9908 42.1453 85.8518 41.1914 84.5627 41.3062C82.9807 41.4445 81.2768 41.5102 79.4439 41.4867C78.1502 41.4727 77.0885 42.5109 77.0744 43.8023C77.058 45.0961 78.0963 46.1602 79.39 46.1742Z",
    fill: "url(#paint13_linear_245_4150)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6813 44.5383C95.0016 43.8282 96.961 42.9188 98.6016 41.8758C99.6914 41.1797 100.015 39.7313 99.3188 38.6391C98.625 37.5492 97.1743 37.2258 96.0821 37.9219C94.7625 38.761 93.1805 39.4828 91.3102 40.0547C90.075 40.4344 89.3766 41.7446 89.7563 42.9821C90.1336 44.2196 91.4461 44.9157 92.6813 44.5383Z",
    fill: "url(#paint14_linear_245_4150)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.611 35.3156C105.717 33.0281 106.142 30.6094 106.034 28.2774C105.973 26.9836 104.874 25.9852 103.582 26.0461C102.291 26.107 101.29 27.2039 101.351 28.4953C101.426 30.0797 101.14 31.7227 100.39 33.2766C99.8275 34.4414 100.315 35.8453 101.48 36.4078C102.645 36.9703 104.049 36.4805 104.611 35.3156Z",
    fill: "url(#paint15_linear_245_4150)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.118 19.9898C101.409 17.6812 99.0915 16.0734 96.565 15.5554C95.297 15.2976 94.0571 16.1132 93.797 17.3812C93.5392 18.6491 94.3571 19.889 95.6228 20.1491C97.0806 20.4468 98.365 21.4476 99.3517 22.7812C100.123 23.8195 101.592 24.0374 102.631 23.2687C103.671 22.4976 103.889 21.028 103.118 19.9898Z",
    fill: "url(#paint16_linear_245_4150)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4995 16.0099C75.0354 1.64978 97.0128 2.5779 84.2183 16.0099H72.4995Z",
    fill: "url(#paint17_linear_245_4150)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4995 19.6475C75.0354 34.0053 97.0128 33.0795 84.2183 19.6475H72.4995Z",
    fill: "url(#paint18_linear_245_4150)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2886 20.1958H87.9823C89.2761 20.1958 90.3261 19.1458 90.3261 17.8521C90.3261 16.5583 89.2761 15.5083 87.9823 15.5083H72.2886C70.9972 15.5083 69.9448 16.5583 69.9448 17.8521C69.9448 19.1458 70.9972 20.1958 72.2886 20.1958Z",
    fill: "url(#paint19_linear_245_4150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_4150",
    x1: 28.125,
    y1: 113.843,
    x2: 121.875,
    y2: 113.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_4150",
    x1: 74.7989,
    y1: 113.843,
    x2: 121.875,
    y2: 113.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_4150",
    x1: 28.4369,
    y1: 83.4583,
    x2: 34.9883,
    y2: 126.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_245_4150",
    x1: 75.1898,
    y1: 98.5263,
    x2: 124.605,
    y2: 126.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_245_4150",
    x1: 21.9895,
    y1: 74.3808,
    x2: 29.0607,
    y2: 41.0473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_245_4150",
    x1: 87.5484,
    y1: 50.055,
    x2: 90.0769,
    y2: 91.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_245_4150",
    x1: 28.125,
    y1: 83.4512,
    x2: 121.875,
    y2: 83.4512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_245_4150",
    x1: 79.8,
    y1: 67.5348,
    x2: 80.8102,
    y2: 105.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_245_4150",
    x1: 49.1977,
    y1: 16.0102,
    x2: 95.4258,
    y2: 70.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_245_4150",
    x1: 49.1978,
    y1: 16.0099,
    x2: 95.426,
    y2: 70.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_245_4150",
    x1: 49.1977,
    y1: 16.0099,
    x2: 95.4258,
    y2: 70.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_245_4150",
    x1: 49.1975,
    y1: 16.0099,
    x2: 95.4256,
    y2: 70.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_245_4150",
    x1: 49.1975,
    y1: 16.0103,
    x2: 95.4257,
    y2: 70.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_245_4150",
    x1: 49.1978,
    y1: 16.0102,
    x2: 95.4259,
    y2: 70.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_245_4150",
    x1: 49.1977,
    y1: 16.0102,
    x2: 95.4258,
    y2: 70.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_245_4150",
    x1: 49.1978,
    y1: 16.0102,
    x2: 95.4259,
    y2: 70.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_245_4150",
    x1: 49.1978,
    y1: 16.0101,
    x2: 95.4259,
    y2: 70.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_245_4150",
    x1: 72.4995,
    y1: 10.7974,
    x2: 88.1909,
    y2: 10.7974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_245_4150",
    x1: 72.4995,
    y1: 24.86,
    x2: 88.1909,
    y2: 24.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_245_4150",
    x1: 49.1979,
    y1: 16.0099,
    x2: 95.4261,
    y2: 70.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.4073bc6d6684c18ae89b20b9910e519b.svg";
export { ForwardRef as ReactComponent };